import * as React from 'react';

// tslint:disable:max-line-length
export const FuelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
    <g fillRule="nonzero">
      <path d="M3.45 2.721l1.43-1.43A5.979 5.979 0 0 0 1 0H0v2h1a4.066 4.066 0 0 1 2.45.721zM14 1H8L3 6v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a2 2 0 0 0-2-2zm-1 4H9a1 1 0 1 1 0-2h4a1 1 0 0 1 0 2z" />
    </g>
  </svg>
);
